import styles from './styles'

const GatedContentModal = ({ children, thankYouClassName }) => {
  return (
    <div className={`${styles.wrapper} ${thankYouClassName ? thankYouClassName : ''}`}>
      <div className={styles.modal}>{children}</div>
    </div>
  )
}

export default GatedContentModal
